define([
    '../Util/defaultValue',
    '../Util/defined',
    '../Util/encode',
    '../Util/callbackSystem'
], function (
    defaultValue,
    defined,
    encode,
    callbackSystem
) {
    'use strict'

    /**
     * 人工模型图层。
     * <br /><br />
     * <div align='center'>
     * <img src='images/ModelLayer.png' width='900' height='650' /><br />
     * 人工模型效果图
     * </div>
     * 
     * @demo {@link http://lbs.zjkelan.com/ModelLayer.html|CooWasm ModelLayer demo}
     * @alias ModelLayer
     * @constructor
     *
     * @param {Object} props 包含如下属性的Object：
     * @param {String} props.url 人工模型数据的0.c3s.zip索引文件路径。
     * @param {Number} [props.visibilityDistance=1000] 人工模型数据可视距离，单位：米。
     * @param {Boolean} [props.bVisible=true] 人工模型数据加载时显隐状态。
     * @param {Boolean} [props.bCast=false] 人工模型数据是否参与阴影投射。
     * @param {Boolean} [props.bReceive=false] 人工模型数据是否接受阴影附着效果。
     * @param {Number} [props.saturation=0.0] 人工模型数据饱和度，范围-1.0～1.0。
     * @param {Number} [props.contrast=0.0] 人工模型数据对比度，范围-1.0～1.0。
     * @param {Number} [props.brightness=0.0] 人工模型数据亮度，范围-1.0～1.0。
     * @param {Number} [props.transparency=1.0] 人工模型数据透明度，范围0.0～1.0。
     * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
     * @example
     * var layer = new CooWasm.ModelLayer({
     *     url:"http://127.0.0.1/0.c3s.zip"
     * },(state)=>{console.log("load status:" + state)})
     */
    class ModelLayer {
        /**
         * @description 人工模型数据路径。
         * @type {String}
         */
        url
        /**
         * @description 人工模型数据显隐状态。
         * @type {Boolean}
         * @default true
         */
        bVisible = true
        /**
         * @description 人工模型数据是否参与阴影投射。
         * @type {Boolean}
         * @default false
         */
        bCast = false
        /**
         * @description 人工模型数据是否接受阴影附着效果。
         * @type {Boolean}
         * @default false
         */
        bReceive = false
        /**
         * @description 人工模型数据饱和度。
         * @type {Number}
         * @default 0.0
         */
        saturation = 0.0
        /**
         * @description 人工模型数据对比度。
         * @type {Number}
         * @default 0.0
         */
        contrast = 0.0
        /**
         * @description 人工模型数据亮度。
         * @type {Number}
         * @default 0.0
         */
        brightness = 0.0
        /**
         * @description 人工模型数据透明度。
         * @type {Number}
         * @default 1.0
         */
        transparency = 1.0
        /**
         * @description 人工模型数据是否压缩。
         * @type {Boolean}
         * @readonly
         */
        bCompress
        /**
         * @description 人工模型数据可视距离。
         * @type {Number}
         * @readonly
         */
        visibilityDistance
        /**
         * @description 是否为大文件格式数据。
         * @type {Boolean}
         * @readonly
         */
        bDataBase
        /**
         * @description 人工模型对象uuid。
         * @type {String}
         * @readonly
         */
        avatarUuid = null
        /**
         * @description 人工模型组件uuid。
         * @type {String}
         * @readonly
         */
        componentUuid = null
        /**
         * @description ModelLayer在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "ModelLayer"
        static avatarType = "deCore.Layers.ModelLayer"
        static componentType = "AvatarComponent.DataSource.C3SSModelSourceComponent"
        static otherComponentType = "AvatarComponent.RenderComponent.RenderComponent"
        constructor(props, callback) {
            if (!defined(props)) {
                props = {}
            }
            if (defined(props.build) && props.build == true) {
                return
            }
            if (!defined(props.url)) {
                console.log("ModelLayer need url!")
                return
            }
            this.url = props.url
            this.visibilityDistance = defaultValue(props.visibilityDistance, 1000)
            this.bVisible = defaultValue(props.bVisible, true)
            var connectUrl = encode(this.url)
            var aCategory = encode("deCore.Layers")
            var aName = encode("ModelLayer")
            var cCategory = encode("AvatarComponent.DataSource")
            var cName = encode("C3SSModelSourceComponent")
            var otherCategoryName = "AvatarComponent.RenderComponent.RenderComponent"
            var otherCategoryNames = ""
            var otherComponetProps = ""
            var aProps = ""
            aProps += this.toStr("saturation", props.saturation, "Saturation")
            aProps += this.toStr("contrast", props.contrast, "Contrast")
            aProps += this.toStr("brightness", props.brightness, "Value")
            aProps += this.toStr("transparency", props.transparency, "Transparency")
            aProps += this.toStr("bVisible", props.bVisible, "Visible")
            //C3SSModelSourceComponent porps
            var cProps = "VisibilityDistance:" + this.visibilityDistance + "|"
            //RenderComponent props
            var otherProps = ""
            otherProps += this.toStr("bCast", props.bCast, "CastShadow")
            otherProps += this.toStr("bReceive", props.bReceive, "ReceiveShadow")
            otherCategoryNames += otherCategoryName + "#$%"
            otherComponetProps += otherProps + "#$%"
            var idInfo = Element.prototype.NativeAPI.LoadAvatarAndComponent(connectUrl, aCategory, aName, encode(aProps), cCategory, cName, encode(cProps), encode(otherCategoryNames), encode(otherComponetProps), this.bVisible, true)
            if (idInfo != "") {
                var idArray = idInfo.split("#$%")
                this.avatarUuid = idArray[0]
                this.componentUuid = idArray[1]
                if (idArray.length > 2) {
                    this.otherComponentUuid = idArray[2]
                }
                callbackSystem.register("LoadAvatarAndComponent", this.avatarUuid, (state) => {
                    this.getProperties()
                    if (defined(callback)) {
                        callback(state)
                    }
                    Element.prototype.Map.modelLayers.push(this)
                })
            }
        }

        toStr(memName, value, key) {
            let result = ""
            if (defined(value)) {
                this[memName] = value
                if (typeof value.toStr === 'function') {
                    result = key + ":" + value.toStr() + "|"
                } else {
                    result = key + ":" + value + "|"
                }
            }
            return result
        }

        /**
         * <p>
         * 更新单个或者多个对象属性，使之立即生效。
         * </p>
         * <p>
         * 一般用于多个属性的同时更新，避免性能开销过大。（待启用）
         * </p>
         *
         * @param {Object} [props] 包含如下属性的Object。
         * @param {String} [props.url] 人工模型数据的0.c3s.zip索引文件路径。
         * @param {Boolean} [props.bVisible] 人工模型数据加载时显隐状态。
         * @param {Boolean} [props.bCast] 人工模型数据是否参与阴影投射。
         * @param {Boolean} [props.bReceive] 人工模型数据是否接受阴影附着效果。
         * @param {Number} [props.saturation] 人工模型数据饱和度，范围-1.0～1.0。
         * @param {Number} [props.contrast] 人工模型数据对比度，范围-1.0～1.0。
         * @param {Number} [props.brightness] 人工模型数据亮度，范围-1.0～1.0。
         * @param {Number} [props.transparency] 人工模型数据透明度，范围0.0～1.0。
         * @param {CallbackBoolean} [callback=null] 更新成功后触发的函数回调。
         * @example
         * layer.update({
         *    bVisible:false
         * },(state)=>{console.log("update status:" + state)})
         */
        update(props, callback) {
            let avatarProps = ""
            let componentProps = ""
            let c3ssComponentProps = ""
            let otherComponentProps = ""
            let uuids = ""
            if (defined(props)) {
                if (defined(props.bVisible)) {
                    this.bVisible = props.bVisible
                    avatarProps += "Visible:" + this.bVisible + "|"
                }
                if (defined(props.saturation)) {
                    this.saturation = props.saturation
                    avatarProps += "Saturation:" + this.saturation + "|"
                }
                if (defined(props.contrast)) {
                    this.contrast = props.contrast
                    avatarProps += "Contrast:" + this.contrast + "|"
                }
                if (defined(props.brightness)) {
                    this.brightness = props.brightness
                    avatarProps += "Value:" + this.brightness + "|"
                }
                if (defined(props.transparency)) {
                    this.transparency = props.transparency
                    avatarProps += "Transparency:" + this.transparency + "|"
                }
                //c3ss
                if (defined(props.url)) {
                    this.url = props.url
                    c3ssComponentProps += "URL:" + this.url + "|"
                }
                if (defined(props.visibilityDistance)) {
                    this.visibilityDistance = props.visibilityDistance
                    c3ssComponentProps += "VisibilityDistance:" + this.visibilityDistance + "|"
                }
                componentProps += c3ssComponentProps + "#$%"
                uuids += this.componentUuid + "#$%"
                //render
                if (defined(props.bCast)) {
                    this.bCast = props.bCast
                    otherComponentProps += "CastShadow:" + this.bCast + "|"
                }
                if (defined(props.bReceive)) {
                    this.bReceive = props.bReceive
                    otherComponentProps += "ReceiveShadow:" + this.bReceive + "|"
                }
                componentProps += otherComponentProps + "#$%"
                uuids += this.otherComponentUuid + "#$%"
                callbackSystem.register("UpdateAvatarAndMultiComponent", this.avatarUuid, (state) => {
                    this.getProperties()
                    if (defined(callback)) {
                        callback(state)
                    }
                })
                Element.prototype.NativeAPI.UpdateAvatarAndMultiComponent(encode(this.avatarUuid), encode(uuids), encode(avatarProps), encode(componentProps), defined(callback))
            }
        }

        /**
         * 从场景中定位自身(自动根据数据包围盒定位，不可修改定位参数)。
         * @param {CallbackBoolean} [callback=null] 飞行结束后触发的函数回调。
         * @example
         * // 定位图层
         * layer.locate(()=>{console.log("locate done!")})
         */
        locate(callback) {
            callbackSystem.register("", "LocateAvatar", (state) => {
                if (defined(callback)) {
                    callback(state)
                }
            })
            Element.prototype.NativeAPI.LocateAvatar(encode(this.avatarUuid))
        }

        /**
         * 获取图层包含的属性。
         * @returns {Boolean} 是否获取成功。获取成功时，会自动赋值给属性。
         * @example
         * // 获取属性
         * layer.getProperties()
         * console.log(layer.bCompress)
         */
        getProperties() {
            if (!defined(this.avatarUuid) || !defined(this.componentUuid)) {
                console.log("uuid require!")
                return false
            }
            let pAvatarUuid = Element.prototype.NativeAPI.Uuid_New()
            Element.prototype.NativeAPI.Uuid_SetId(pAvatarUuid, encode(this.avatarUuid))
            let pAvatar = Element.prototype.NativeAPI.MapImpl_getAvatar(pAvatarUuid)
            let avatarPropSize = Element.prototype.NativeAPI.Avatar_GetPropertiesSize(pAvatar)
            for (let i = 0; i < avatarPropSize; ++i) {
                let pProp = Element.prototype.NativeAPI.Avatar_GetProperty(pAvatar, i)
                let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                if (name == "Visible") {
                    if (value == "true" || value == "1") {
                        this.bVisible = true
                    } else {
                        this.bVisible = false
                    }
                } else if (name == "Saturation") {
                    this.saturation = parseFloat(value)
                } else if (name == "Contrast") {
                    this.contrast = parseFloat(value)
                } else if (name == "Value") {
                    this.brightness = parseFloat(value)
                } else if (name == "Transparency") {
                    this.transparency = parseFloat(value)
                }
            }
            let avatarAcSize = Element.prototype.NativeAPI.Avatar_GetAvatarComponentsSize(pAvatar)
            for (let j = 0; j < avatarAcSize; ++j) {
                let pAc = Element.prototype.NativeAPI.Avatar_GetAvatarComponent(pAvatar, j)
                let propSize = Element.prototype.NativeAPI.AvatarComponent_GetPropertiesSize(pAc)
                let pObjType = Element.prototype.NativeAPI.AvatarComponent_GetObjectType(pAc)
                let pName = Element.prototype.NativeAPI.ObjectType_GetName(pObjType)
                let pUuid = Element.prototype.NativeAPI.AvatarComponent_GetUuid(pAc)
                let uuid = Element.prototype.NativeAPI.Uuid_GetId(pUuid)
                if (pName == "C3SSModelSourceComponent") {
                    this.componentUuid = uuid
                    for (let z = 0; z < propSize; ++z) {
                        let pProp = Element.prototype.NativeAPI.AvatarComponent_GetProperty(pAc, z)
                        let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                        let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                        if (name == "Compress") {
                            if (value == "true" || value == "1") {
                                this.bCompress = true
                            } else {
                                this.bCompress = false
                            }
                        } else if (name == "VisibilityDistance") {
                            this.visibilityDistance = Number(value)
                        } else if (name == "DataBase") {
                            if (value == "true" || value == "1") {
                                this.bDataBase = true
                            } else {
                                this.bDataBase = false
                            }
                        }
                    }
                } else if (pName == "RenderComponent") {
                    this.otherComponentUuid = uuid
                    for (let z = 0; z < propSize; ++z) {
                        let pProp = Element.prototype.NativeAPI.AvatarComponent_GetProperty(pAc, z)
                        let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                        let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                        if (name == "CastShadow") {
                            if (value == "true" || value == "1") {
                                this.bCast = true
                            } else {
                                this.bCast = false
                            }
                        } else if (name == "ReceiveShadow") {
                            if (value == "true" || value == "1") {
                                this.bReceive = true
                            } else {
                                this.bReceive = false
                            }
                        }
                    }
                }

            }
            Element.prototype.NativeAPI.Avatar_Delete(pAvatar)
            Element.prototype.NativeAPI.Uuid_Delete(pAvatarUuid)
            return true
        }
        /**
         * 从场景中销毁自身。
         * @param {CallbackBoolean} [callback=null] 销毁图层后触发的函数回调。
         * @returns null 空值。
         * @example
         * // 销毁图层
         * layer = layer.destroy((state)=>{console.log("destroy status:" + state)})
         */
        destroy(callback) {
            if (!defined(this.avatarUuid)) {
                console.log("avatarUuid is null!")
                return null
            }
            callbackSystem.register("RemoveAvatar", this.avatarUuid, (state) => {
                if (defined(callback)) {
                    callback(state)
                }
                Element.prototype.Map.modelLayers = Element.prototype.Map.modelLayers.filter(item => item !== this)
                callbackSystem.remove("LoadAvatarAndComponent", this.avatarUuid)
                callbackSystem.remove("UpdateAvatarAndMultiComponent", this.avatarUuid)
                callbackSystem.remove("", "LocateAvatar")
                callbackSystem.remove("RemoveAvatar", this.avatarUuid)
                this.avatarUuid = null
                this.componentUuid = null
                this.otherComponentUuid = null
            })
            Element.prototype.NativeAPI.RemoveAvatar(encode(this.avatarUuid))
            return null
        }
    }
    return ModelLayer
})